/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CalendarDay/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import ActionsPopover from './ActionsPopover/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentHover from 'DesignSystem/Popover/PopoverContentHover/index'
import PopoverContentRightClick from 'DesignSystem/Popover/PopoverContentRightClick/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import SlotsPopover from './SlotsPopover/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import WeekIndicator from './WeekIndicator/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function CalendarDay({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/MonthlyCalendar/Content/CalendarDay"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let calendarDayIsOfficeDayValueData = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'is_office_day',
})
let calendarDayTemplateColorValueData = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'template_color',
})
let calendarDayNotIncludedInSidebarFiltersValueData = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'not_included_in_sidebar_filters',
})
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let calendarDayIsSelectedValueData = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'is_selected',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let calendarDayDayValueData = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'day',
})
let calendarDayIsSelectedValueData1 = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'is_selected',
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let calendarDayOccupancyColorValueData = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'occupancy_color',
})
let calendarDayHasPercentageOfOccupancyValueData = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'has_percentage_of_occupancy',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
 showOnHover={true}
 hoverTriggerDelay={1000}
 showOnClick={false}
 showOnRightClick={true}
 offsetMainAxis={-8}
 data="calendar_day.is_office_day"
 disabled={!calendarDayIsOfficeDayValueData}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<button
  data-testid="CalendarDay.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bc-1-2rE2z8': dtColorsNeutral200,'--bc-3-2rE2z8': calendarDayTemplateColorValueData,'--o-2-2rE2z8': calendarDayNotIncludedInSidebarFiltersValueData ? 0.4 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="CalendarDay.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-3-2rE2z8': calendarDayIsSelectedValueData ? dtColorsNeutral900 : "transparent",'--btlr-4-2rE2z8': calendarDayIsSelectedValueData ? "50%" : "0%",'--btrr-5-2rE2z8': calendarDayIsSelectedValueData ? "50%" : "0%",'--bblr-6-2rE2z8': calendarDayIsSelectedValueData ? "50%" : "0%",'--bbrr-7-2rE2z8': calendarDayIsSelectedValueData ? "50%" : "0%"}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="semibold"
 color={calendarDayIsSelectedValueData1 ? dtColorsWhite : dtColorsNeutral500}
 data="calendar_day.day"
 text={calendarDayDayValueData}
 data="calendar_day.is_selected"
/>
<div
  data-testid="CalendarDay.Horizontal"
  data-view-path={viewPath}
 style={{'--w-8-2rE2z8': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--h-9-2rE2z8': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-3-2rE2z8': calendarDayOccupancyColorValueData,'--o-2-2rE2z8': calendarDayHasPercentageOfOccupancyValueData ? 1 : 0}}
 className={`views-block ${styles.Horizontal}`}
/>
</div>
<WeekIndicator
  viewPath={`${viewPath}/WeekIndicator`}
/>
</button>
)}
</PopoverTrigger>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
>
{childProps => (
<SlotsPopover
{...childProps}
  viewPath={`${viewPath}/SlotsPopover`}
/>
)}
</PopoverContentHover>
<PopoverContentRightClick
{...childProps}
  viewPath={`${viewPath}/PopoverContentRightClick`}
>
{childProps => (
<ActionsPopover
{...childProps}
  viewPath={`${viewPath}/ActionsPopover`}
/>
)}
</PopoverContentRightClick>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}